import { useMemo, useRef } from "react";
import { Box, ButtonBase } from "@mui/material";
import { ChevronDown16Regular } from "@/components/Icon";
import CustomModelDialog from "@/components/CustomModelDialog/CustomModelDialog";
import { useDesignMode } from "@/features/designMode/designModeStore";
import { useMockModelPicker } from "@/features/mockModel/useMockModelPicker";
import { providerKey } from "./AiAskBarHomeRightAgentSelect.helpers";
import { PROVIDER_ORDER } from "./AiAskBarHomeRightAgentSelect.constants";
import ModelMenu from "./AiAskBarHomeRightAgentSelectModelMenu";
import ProviderMenu from "./AiAskBarHomeRightAgentSelectProviderMenu";
import { useAgentSelectMenuState } from "./useAgentSelectMenuState";
import { useAiAskBarSelectedModel } from "./useAiAskBarSelectedModel";
import { useAiModelCatalog } from "./useAiModelCatalog";
import styles from "./index.module.scss";
export default function AiAskBarHomeRightAgentSelectView({ value, onChange, landing = false }) {
  const catalog = useAiModelCatalog();
  const designMode = useDesignMode();
  const real = useAiAskBarSelectedModel({ catalog, value, selectedModel: value });
  const menu = useAgentSelectMenuState();
  const mock = useMockModelPicker({ selection: real, onChange, close: menu.close });
  const providerListRef = useRef(null);
  const autoOption = useMemo(() => catalog.tiers.find((t) => t.value === "auto"), [catalog.tiers]);
  const providers = useMemo(() => {
    const uniq = [...new Set(catalog.models.map((m) => m.provider).filter(Boolean))];
    const map = new Map(uniq.map((p) => [providerKey(p), p]));
    return [...PROVIDER_ORDER.map((k) => map.get(k)).filter(Boolean), ...uniq.filter((p) => !PROVIDER_ORDER.includes(providerKey(p)))];
  }, [catalog.models]);
  const hoveredModels = useMemo(() => (!menu.hoveredProvider ? [] : catalog.models.filter((m) => providerKey(m.provider) === providerKey(menu.hoveredProvider))), [catalog.models, menu.hoveredProvider]);
  if (designMode) return null;
  const labelClass = `${styles.agentControlModel}${mock.label ? ` ${styles.agentControlModelClamp}` : ""}`;
  return (
    <>
      <ButtonBase type="button" onClick={menu.openAt} aria-label="Select Model" aria-haspopup="menu" aria-expanded={menu.open} className={`${styles.agentControlButton}${landing ? ` ${styles.agentControlButtonLanding}` : ""}`}>
        <Box component="span" className={labelClass}>{mock.label ?? real.selectedOption.label}</Box>
        <ChevronDown16Regular className={styles.agentControlButtonChevron} aria-hidden />
      </ButtonBase>
      <ProviderMenu open={menu.open} anchorEl={menu.anchorEl} onClose={menu.close} listRef={providerListRef} autoOption={autoOption} providers={providers} catalog={catalog} selection={mock.selection} hoveredProvider={menu.hoveredProvider} onProviderEnter={menu.enterProvider} onSelect={mock.selectReal} mock={mock} />
      <ModelMenu open={Boolean(menu.hoveredProvider && menu.hoveredAnchor && menu.open && hoveredModels.length)} anchorEl={menu.hoveredAnchor} onClose={menu.close} hoveredProvider={menu.hoveredProvider} models={hoveredModels} selection={mock.selection} onSelect={mock.selectReal} />
      <CustomModelDialog open={mock.dialogOpen} saved={mock.custom} onClose={mock.closeCustom} onSave={mock.saveCustom} onRemove={mock.removeCustom} />
    </>
  );
}
